<div class="container">
  <mat-toolbar color="primary" class="toolbar-over-card">
    <mat-card-title>Edit Case Note</mat-card-title>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
      <button mat-icon-button matTooltip="More...." [matMenuTriggerFor]="contactMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <input type="file" class="file-input" (change)="onImportFileSelected($event)" style="display: none" #fileUpload>
      <mat-menu #contactMenu="matMenu" class="import-export">
        <button mat-menu-item (click)="exportCaseNotes()">
          <mat-icon>file_download</mat-icon>
          Export All Notes
        </button>
        <button mat-menu-item (click)="fileUpload.click()">
          <mat-icon>file_upload</mat-icon>
          Import Notes
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
  <mat-card appearance="outlined" class="scrollable-content">
    <div style="font-size: 15px" *ngIf="!caseNote">
      Please select a case note
    </div>
    <mat-card-content *ngIf="caseNote">
      <div [formGroup]="caseNotesForm" style="width: 50%;">
          <div class="form-control-wrapper">
            <mat-form-field appearance="outline" color="primary" style="margin-top: 10px;">
              <mat-label>Note</mat-label>
              <textarea matInput placeholder="Note content" cdkTextareaAutosize formControlName="description"
                style="min-height: 100px;"></textarea>
                <mat-error *ngIf="caseNotesForm.invalid && caseNotesForm.dirty" style="display: flex; flex-direction: column; gap: 8px;">
                  <ng-container *ngIf="caseNotesForm.controls['description'].errors?.maxlength">
                      Note must be at most 8000 characters long.
                  </ng-container>
                  <ng-container *ngIf="caseNotesForm.controls['description'].errors?.pattern">
                      Note must not contain < or >.
                  </ng-container>
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="caseNote.documentName !== ''" class="form-control-wrapper">
            <button mat-raised-button (click)="openDocument(caseNote)" color="primary">
              <div class="document-button-text">
                <mat-icon>launch</mat-icon>
                <div>{{caseNote.documentName}}</div>
              </div>
            </button>
          </div>
          <div class="created-by">
            <div><i>Updated by <strong>{{caseNote.author}}</strong> on {{caseNote.createdAt | date: 'medium'}}</i>
            </div>
          </div>
      </div>
    </mat-card-content>
    <mat-card-actions *ngIf="caseNote" class="right">
      <div *inRole="roles.EditFeatureSet">
        <button mat-button color="primary" [disabled]="isSaveDisabled()" (click)="save()">Save</button>
        <button mat-button color="primary" [disabled]="isSaveDisabled()" (click)="cancel()">Cancel</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>